import { withContext } from './withContext';
import LoadingContext from '../../contexts/LoadingContext';
import LoadingManager from '../../client-server-utils/loading/LoadingManager';

export default withContext(LoadingContext, 'loadingManager');

export type WithLoadingContextProps = {
  loadingManager: LoadingManager;
};
